export default {
  methods: { 
    isFlagInList(flagSlug, contact) {
      console.log("isFlagInList Parameters:", flagSlug, contact);
      if (!contact || !Array.isArray(contact.contactFlags)) return false;

      const flag = contact.contactFlags.find(
        (flag) => flag.slug === flagSlug
      );
      console.log("isFlagInList Status:", !!flag?.status); 
      return !!flag?.status;
    }
  }
};
